/**
 * TBB Mega Menu — Click-to-Open Behavior
 * ----------------------------------------------------------------------
 * Replaces the previous hover/focus-within reveal with explicit click +
 * keyboard interaction. Hover sweeping near the nav no longer pops the
 * menu accidentally.
 *
 * Behavior:
 *   - Click trigger              → toggle open/closed
 *   - Enter / Space on trigger   → toggle (since trigger is role="button")
 *   - Click outside              → close
 *   - Escape key                 → close
 *   - Modifier-click (cmd/ctrl/shift/alt) on an <a> trigger → fall through
 *     to default link navigation (e.g. open in new tab)
 *
 * ARIA:
 *   - aria-expanded mirrored on the trigger button on every state change
 *
 * Idempotent — single global init guard so multiple snippet renders
 * (mobile drawer + desktop) don't re-bind handlers.
 */
(function () {
  'use strict';

  if (window.__tbbMegaMenuInit) return;
  window.__tbbMegaMenuInit = true;

  function getTriggerButton(triggerLi) {
    return triggerLi.querySelector('[role="button"], a, span');
  }

  function setExpanded(triggerLi, expanded) {
    triggerLi.classList.toggle('is-open', expanded);
    var btn = getTriggerButton(triggerLi);
    if (btn) btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function closeAll() {
    document.querySelectorAll('.tbb-mega-menu-trigger.is-open').forEach(function (t) {
      setExpanded(t, false);
    });
  }

  function toggle(triggerLi) {
    var wasOpen = triggerLi.classList.contains('is-open');
    closeAll();
    if (!wasOpen) setExpanded(triggerLi, true);
  }

  function init() {
    // Bind only to desktop triggers — mobile context renders the menu
    // inline in the drawer with native <details>/<summary> accordions
    // which already have their own click toggle.
    var triggers = document.querySelectorAll('.tbb-mega-menu-trigger');
    if (!triggers.length) return;

    triggers.forEach(function (li) {
      // Skip if this trigger doesn't actually contain a desktop mega
      // panel (e.g. mobile-only render).
      if (!li.querySelector('.tbb-mega-menu--desktop')) return;

      var btn = getTriggerButton(li);
      if (!btn || btn.dataset.tbbMegaBound) return;
      btn.dataset.tbbMegaBound = '1';

      btn.addEventListener('click', function (e) {
        // Modifier-click on an <a>: let the browser handle it (open in
        // new tab, etc.) — don't toggle.
        if (btn.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return;
        e.preventDefault();
        toggle(li);
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          toggle(li);
        }
      });
    });

    // Click outside any open trigger closes the menu.
    document.addEventListener('click', function (e) {
      var openTrigger = document.querySelector('.tbb-mega-menu-trigger.is-open');
      if (!openTrigger) return;
      if (openTrigger.contains(e.target)) return;
      closeAll();
    });

    // Escape closes.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
